import {useContext} from 'react'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import {ReplenishmentReportPageContext} from '../../contexts'
import ReplenishmentReportTableRow from './ReplenishmentReportTableRow'
import {getReplenishmentReportTableColumns} from '../../utils'

const ReplenishmentReportTable = () => {
  const {
    replenishmentReportList,
    isLoading,
    onSortingChange,
    filters,
    hasWritePermission,
    meta,
  }: any = useContext(ReplenishmentReportPageContext)
  const columns = getReplenishmentReportTableColumns(meta)
  
  return (
    <DynamicTable
      id='kt_table_replenishment_report'
      data={replenishmentReportList}
      sortableColumns={columns}
      TableRow={ReplenishmentReportTableRow}
      loading={isLoading}
      filters={filters}
      onSortingChange={onSortingChange}
      tableClass='table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-15'
      tableHeaderClass='table-row-bordered'
      hasPermission={hasWritePermission}
    />
  )
}

export default ReplenishmentReportTable
